import { render, staticRenderFns } from "./DailyBriefs.vue?vue&type=template&id=7f015e93&scoped=true"
import script from "./DailyBriefs.vue?vue&type=script&lang=js"
export * from "./DailyBriefs.vue?vue&type=script&lang=js"
import style0 from "./DailyBriefs.vue?vue&type=style&index=0&id=7f015e93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f015e93",
  null
  
)

export default component.exports